export default __webpack_public_path__ + "4fca74090058fa0fec78dda1cee7fe31.svg";